import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, ComboService, rgrnService, StockService  } from "../../../services/index";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./RgrnComponent.html",
})
export class RgrnComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  designnoList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    rgrn_no: "",
    shirt_design_no: "",
    from_date: "",
    to_date: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "r.rgrn_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private rgrnService: rgrnService,
    private stkService: StockService,
    public toasterService: ToasterService,
    private comboservice: ComboService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.getDesignNoList();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Ref No",
        prop: "ref_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Date",
        prop: "date",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "RGRN No",
        prop: "rgrn_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "WO No",
        prop: "wo_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      //      {name: 'Party Code',prop: 'party_code',headerClass:'text-center', minWidth: 130,maxWidth: 130,width: 130 },
      {
        name: "Shirt DNo",
        prop: "shirt_design_no",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "F.Tot",
        prop: "ftot_pcs",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 70,
      },
      {
        name: "H.Tot",
        prop: "htot_pcs",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 70,
      },
      {
        name: "Total",
        prop: "total_pcs",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 70,
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }
  getDesignNoList() {
    let params = {};
    this.comboservice.getDesignCombo(params).then((res: any) => {
      this.designnoList = res;
    });
  }
  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.from_date = "";
    this.filter.to_date = "";
    this.filter.rgrn_no = "";
    this.filter.shirt_design_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getOrderList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  addEditPO(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD RGRN DETAILS",
          title: "ADD RGRN DETAILS",
          tabParent: "PURCHASE",
          mode: mode,
          data: row,
          name: "ADD RGRN DETAILS",
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT RGRN DETAILS",
          title: "EDIT RGRN DETAILS",
          tabParent: "PURCHASE",
          mode: mode,
          data: row,
          name: "EDIT RGRN DETAILS",
        },
      };
    } else {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW RGRN DETAILS",
          title: "VIEW RGRN DETAILS",
          tabParent: "PURCHASE",
          mode: mode,
          data: row,
          name: "VIEW RGRN DETAILS",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }


  bagMaterialPrint(row) {
    let params = {
      setSize_id: row.rgrn_id
    };

    let that = this;
    that.rgrnService.getworkOrder(params).then((res: any) => {

      if (res.success) {
        that.calculateMaterials(res)
       
      }
    });
  }

  setBarcodePrint(row){
    let params = {
      rgrn_no: row.rgrn_no,
      rgrn_date: row.rgrn_date
    };

    let that = this;
    this.stkService.getRgrndata(params).then(function (res: any) {
      if (res.data.length) {
        let data = res.data.map(item => ({ design: item.dispName, barcode: item.barcode, size: item.size_sleeve, setName: item.set_name, setNo: item.set_cnt, rgrn: row.rgrn_no, date: row.date }));

        let params = {
          data: JSON.stringify(data)
        }

        that.rgrnService.BarcodeSetPrint(params).then(function (res: any) { })
      }
    });

  }

 calculateMaterials(res) {

    let sizeList = res.sizeList;
    let desList = res.desList;
    let damList = res.damList;
    let materialList = res.materialList;
    let combinedSet = res.combinedSet;
    if (res.combinedSet.length > 0) {
          combinedSet.forEach(entry => {
            const matchedMaterial = materialList.find(mat => mat.capacity === entry.set_per);
            if (matchedMaterial) {
              entry.item = matchedMaterial.prefix;
            }
          });
    }

      // Step 2: Initialize materialList with needed = 0
   materialList = materialList.map(mat => ({
      ...mat,
      needed: 0
    }));

  //   // Step 3: For each set, find matching material by capacity == set_per
    combinedSet.forEach(set => {
      const matchingMaterial = materialList.find(m => m.prefix == set.item);
      if (matchingMaterial) {
        matchingMaterial.needed += set.setCount || 0;
      }
    });

     //   // Final Output
   materialList = materialList.filter(m => m.needed > 0)

  let result = this.updateCombinedSet(combinedSet, sizeList, damList);


    let obj = {
      desList: JSON.stringify(desList),
     combinedSet :  JSON.stringify(result),
     materialList: JSON.stringify(materialList)
    }
    console.log(materialList, result, combinedSet)

    this.rgrnService.bagMaterialPrint(obj).then(function (res: any) { })

  }












   updateCombinedSet(combinedSet, sizeList, damList) {

    // First, find the last index of each shade
    const lastShadeIndices = {};
    combinedSet.forEach((item, index) => {
        lastShadeIndices[item.shade] = index;
    });

    // Create maps for quick lookup (handle empty arrays)
    const sizeMap = {};
    const damMap = {};

    // Only process sizeList if it has items
    if (sizeList && sizeList.length > 0) {
        sizeList.forEach(item => {
            sizeMap[item.shade] = item;
        });
    }

    // Only process damList if it has items
    if (damList && damList.length > 0) {
        damList.forEach(item => {
            damMap[item.shade] = item;
        });
    }

    // Define all possible fields
    const sizeFields = [
        'f36', 'f38', 'f40', 'f42', 'f44', 'f46', 'ftot',
        'h36', 'h38', 'h40', 'h42', 'h44', 'h46', 'htot', 'tot'
    ];

    const damFields = [
        'df36', 'df38', 'df40', 'df42', 'df44', 'df46', 'dftot',
        'dh36', 'dh38', 'dh40', 'dh42', 'dh44', 'dh46', 'dhtot', 'dtot'
    ];

    // Update the combinedSet
    return combinedSet.map((item, index) => {
        const shade = item.shade;
        const isLastShadeIndex = lastShadeIndices[shade] === index;
        const newItem = { ...item };

        // Handle size fields
        if (sizeList && sizeList.length > 0) {
            sizeFields.forEach(field => {
                newItem[field] = isLastShadeIndex && sizeMap[shade] 
                    ? (sizeMap[shade][field] || 0) 
                    : 0;
            });
        } else {
            // If sizeList is empty, set all size fields to 0
            sizeFields.forEach(field => {
                newItem[field] = 0;
            });
        }

        // Handle damage fields
        if (damList && damList.length > 0) {
            damFields.forEach(field => {
                newItem[field] = isLastShadeIndex && damMap[shade] 
                    ? (damMap[shade][field] || 0) 
                    : 0;
            });
        } else {
            // If damList is empty, set all damage fields to 0
            damFields.forEach(field => {
                newItem[field] = 0;
            });
        }

        return newItem;
    });
}


  printSticker(res) {
    let params = res.data;
    this.isLoadMask = this.rgrnService
      .printSticker(params)
      .then((res: any) => {});
  }
  getOrderList(): void {
    if (this.filter.from_date) {
      this.filter.from_date = this.datePipe.transform(
        this.filter.from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.to_date) {
      this.filter.to_date = this.datePipe.transform(
        this.filter.to_date,
        "yyyy-MM-dd"
      );
    }

    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      from_date: this.filter.from_date,
      to_date: this.filter.to_date,
      shirt_design_no: this.filter.shirt_design_no,
      rgrn_no: this.filter.rgrn_no,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.rgrnService
      .getCuttingList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
      });
  }

  deleteOrder(row: any): void {
    let that = this;
    swal({
      title: "Are you sure to delete this Cutting Details?",
      text: "You will not be able to recover this" + " " + row["cu_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.rgrnService
          .delete(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getOrderList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/rgrn/RgrnComponent.ts